import { useMutation, gql } from "@apollo/client";
import { CONTRACT_TEMPLATE_FRAGMENT } from "./useGetContractTemplate";

export type ContractTemplate = {
  id?: string;
  slug?: string;
  title: string;
  body: string;
  signatories: string[];
  companyId: string;
};

export const INSERT_CONTRACT_TEMPLATE = gql`
  mutation insertContractTemplate($input: InsertContractTemplateInput!) {
    insertContractTemplate(input: $input) {
      contractTemplate {
        ...ContractTemplateFragment
      }
    }
  }
  ${CONTRACT_TEMPLATE_FRAGMENT}
`;

export default (options = {}) => {
  return useMutation<
    {
      insertContractTemplate: {
        contractTemplate: { id: string; slug: string };
      };
    },
    { input: ContractTemplate }
  >(INSERT_CONTRACT_TEMPLATE, options);
};
